import React, {
  useEffect,
  useState,
  createContext,
  useContext,
  useRef,
} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { Hub } from "aws-amplify";
import { Auth } from "aws-amplify";
import { fetchData } from "./services/BackendServices";
import AlertModal from "./pages/Requirement/components/common/AlerModel";
import { initGA, logPageView } from "./utils/analytics";
import { initUserTracking } from "./services/UserTrackerService";

import AMTPLDashboard from "./components/AMTPL/AMTPLDashboard";
import SellerFarmerDashboardOld from "./components/SellerFarmer/SellerFarmerDashboard";
import AgroPreneurDashboard from "./components/AgroPreneur/AgroPreneurDashboard";

// Seller-Farmer module
import SFLayout from "./pages/seller-farmer/Components/layouts/layout";
import SellerFarmerDashboard from "./pages/seller-farmer/Dashboard";
import SellerFarmerProduce from "./pages/seller-farmer/produce/Produce";
import SellerFarmerProfileModule from "./pages/seller-farmer/profileSetting/ProfileModule";
import SellerFarmerSetting from "./pages/seller-farmer/setting/Setting";
import SellerFarmerSupport from "./pages/seller-farmer/support/Support";
import SellerFarmerMessageModule from "./pages/seller-farmer/message/MessagingModule";
import SellerFarmerDocumentVault from "./pages/seller-farmer/DocumentVault/DocumentVault";
import SellerFarmerRequirementModule from "./pages/seller-farmer/requirement/RequirementModule";
import SellerFarmerRfqOffersModule from "./pages/seller-farmer/rfqOffers/RfqOffersModule";
import LoginAuto from "./components/Login/LoginAuto";
import BuyerLogin from "./pages/Login/BuyerLogin";
import GlobalPartnerLogin from "./pages/Login/GlobalPartnerLogin";
import SellerFarmerLogin from "./pages/Login/SellerFarmerLogin";
import AgroPreneurLogin from "./pages/Login/AgroPreneurLogin";
import AMTPLLogin from "./pages/Login/AMTPLLogin";
import ForgotPassword from "./pages/Login/ForgotPassword";
import ResetPassword from "./pages/Login/ResetPassword";
import Home from "./components/Home/Home";
import BankInfo from "./components/Home/BankInfo";
import MyClientsDashboard from "./components/MyClients/MyClientsDashboard";
import MyFarmersDashboard from "./components/MyFarmers/MyFarmersDashboard";
import { LoadingProvider } from "./context/LoadingContext";
import LoadingIndicator from "./components/common/LoadingIndicator";
import GoogleAnalyticsTracker from "./components/common/GoogleAnalyticsTracker";
import RequirementModule from "./pages/Requirement/RequirementModule";
import AMTPLRequirementModule from "./pages/Requirement/AMTPLRequirementModule/AMTPLReqModule";
import AMTPLAddRequirementModule from "./pages/Requirement/AMTPLRequirementModule/AMTPLAddRequirement";
import ProductOfferCharges from "./components/AMTPL/master/productOffers/ProductOffer";
import InlandShipping from "./components/AMTPL/master/InlandShipping/Inlandshipping";
import CountryWiseProduct from "./components/AMTPL/master/countryWiseProduct/CountryWiseProduct";
import ProductCategory from "./components/AMTPL/master/productCategory/ProductCategory";
import Product from "./components/AMTPL/master/product/Product";

// Buyer module
import Dashboard1 from "./pages/buyer/Dashboard";
import DiscoverEvaluate from "./pages/buyer/DoscoverEvaluate/DoscoverEvaluate";
import BuyerDashboard from "./components/Buyer/BuyerDashboard";
import BuyerProfileModule from "./pages/buyer/profileSetting/ProfileModule";
import Support from "./pages/buyer/support/Support";
import RequirementBuyerModule from "./pages/buyer/requirement/RequirementBuyerModule";
import RfqOffers from "./pages/buyer/frqOffers/RfqOffers";
import Orders from "./pages/buyer/orders/Orders";
import Layout from "./pages/buyer/Components/layouts/layout";
import Logistic from "./pages/buyer/logistic/Logistics";
import Payment from "./pages/buyer/payment/Payment";
import PageNotFound from "./pages/buyer/not-found/NotFound";
import RfqsOffersModule from "./pages/buyer/finance-marketplace/RfqsOffers/RfqsOffersModule";
import FinanceMarketModule from "./pages/buyer/finance-marketplace/FinanceMarketModule";
import Communication from "./pages/buyer/communication/Communication";
import BuyerSetting from "./pages/buyer/setting/Setting";
import BuyerUserRoleModule from "./pages/buyer/user-role/UserRoleModule";
import BuyerDocumentVault from "./pages/buyer/DocumentVault/DocumentVault";
import BuyerMyTradeDashboard from "./pages/buyer/DoscoverEvaluate/MyTradeBuyerDashboard";
//buyer - end

// AMTPL - module
import AdminLayout from "./pages/AmtplAdmin/Components/layouts/layout";
import AmtplAdminDashboard from "./pages/AmtplAdmin/Dashboard";
import AmtplAdminAnalytics from "./pages/AmtplAdmin/Analytics";
import AmtplProductModule from "./pages/AmtplAdmin/master/productModule/ProductModule";
import AmtplProduce from "./pages/AmtplAdmin/produce/Produce";
import AmtplOffers from "./pages/AmtplAdmin/offers/Offers";
import AmtplEntities from "./pages/AmtplAdmin/entities/Entities";
import AmtplCommunication from "./pages/AmtplAdmin/communication/Communication";
import AmtplTrade from "./pages/AmtplAdmin/trade/Trade";
import AmtplRFQs from "./pages/AmtplAdmin/rfqs/Rfqs";
import AmtplSupport from "./pages/AmtplAdmin/support/Support";
import AmtplSettings from "./pages/AmtplAdmin/settings/Settings";
import AdmDocumentVault from "./pages/AmtplAdmin/DocumentVault/DocumentVault";
import KybModule from "./pages/AmtplAdmin/KYB/KybModule";

//procurement
import AmtplProcurementDashboard from "./pages/AmtplAdmin/procurement/Dashboard";
import StratigicPartners from "./pages/AmtplAdmin/procurement/StratigicPartners";
import ProcurementProjects from "./pages/AmtplAdmin/procurement/ProcurementProjects";
import ProcurementDocumentTypes from "./pages/AmtplAdmin/procurement/ProcurementDocumentTypes";
import ProcurementDocumentVault from "./pages/AmtplAdmin/procurement/DocumentVault/ProcurementDocumentVault";
import ProcurementInvoices from "./pages/AmtplAdmin/procurement/ProcurementInvoices";
import ProcurementMasterModule from "./pages/AmtplAdmin/procurement/ProcurementMasterModule";

// AMTPL- end

// GB -module
import GPLayout from "./pages/global-partner/Components/layouts/layout";
import GPFinanceMarketModule from "./pages/global-partner/my-trade/finance-marketplace/FinanceMarketModule";
import GPRequirementOldModule from "./pages/Requirement/GlobalPartner/RequirementModule";
import GPRequirementModule from "./pages/global-partner/requirement/GPRequirementModule";
import GpRfqOffers from "./pages/global-partner/my-trade/rfqOffers/RfqOffers";
import GpBuyerRfqOffers from "./pages/global-partner/buyer-activity/rfqOffers/RfqOffers";
import GlobalPartnerDashboard from "./components/GlobalPartner/GlobalPartnerDashboard";
import GPDiscoverEvaluate from "./pages/global-partner/my-trade/DiscoverEvaluate/DiscoverEvaluate";
import MyClients from "./pages/global-partner/buyer-activity/client/MyClients";
import GPOffersOld from "./pages/global-partner/my-trade/offers/offero";
import BuyerActivityDashboard from "./pages/global-partner/buyer-activity/Dashboard";
import MyTradeDashboard from "./pages/global-partner/my-trade/DiscoverEvaluate/MyTradeDashboard";
import GPDashboard from "./pages/global-partner/Dashboard";
import GPBuyerRequirementModule from "./pages/global-partner/buyer-activity/requirement/GPRequirementModule";
import GPBuyerOffersModule from "./pages/global-partner/buyer-activity/btradeOffers/OffersModule";
import Trade from "./pages/global-partner/buyer-activity/trade/Trade";
import GpRfqsOffersModule from "./pages/global-partner/my-trade/finance-marketplace/RfqsOffers/GpRfqsOffersModule";

import GPmyTradeProfile from "./pages/global-partner/my-trade/profileSetting/ProfileModule";
// import GPSupport from "./pages/global-partner/my-trade/support/Support";
import GPPayment from "./pages/global-partner/my-trade/payment/Payment";
import GPOrders from "./pages/global-partner/my-trade/orders/Orders";
import GPProfile from "./pages/global-partner/profileSetting/Profile";
import GPTradeMessageModule from "./pages/global-partner/my-trade/message/MessagingModule";
import AmtplMessageModule from "./pages/AmtplAdmin/message/MessagingModule";
import BuyerMessageModule from "./pages/buyer/message/MessagingModule";
import FinanceLogin from "./pages/Login/FinancePartner";
import ProfileStepper from "./pages/Login/ProfileSteps";

import GpDocumentVault from "./pages/global-partner/my-trade/DocumentVault/DocumentVault";
import ProfilekycStepper from "./components/Login/ProfileSteps";
import GPSupport from "./pages/global-partner/my-trade/support/Support";
import GPSetting from "./pages/global-partner/my-trade/setting/Setting";
// GB- end

//FP - start
import FPDashboard from "./pages/finance-partner/Dashboard";
import FPLayout from "./pages/finance-partner/Components/layouts/layout";
import FPFinanceRfq from "./pages/finance-partner/FinanceRfq";
import KycModule from "./pages/AmtplAdmin/KYC/KycModule";

//FP - end

//
// import BuyerDashboard from "./components/Buyer/BuyerDashboard";
// import GlobalPartnerDashboard from "./components/GlobalPartner/GlobalPartnerDashboard";
// import AMTPLDashboard from "./components/AMTPL/AMTPLDashboard";
// import SellerFarmerDashboard from "./components/SellerFarmer/SellerFarmerDashboard";
// import AgroPreneurDashboard from "./components/AgroPreneur/AgroPreneurDashboard";
// import BuyerLogin from "./pages/Login/BuyerLogin";
// import GlobalPartnerLogin from "./pages/Login/GlobalPartnerLogin";
// import SellerFarmerLogin from "./pages/Login/SellerFarmerLogin";
// import AgroPreneurLogin from "./pages/Login/AgroPreneurLogin";
// import Home from "./components/Home/Home";
// import MyClientsDashboard from "./components/MyClients/MyClientsDashboard";
// import MyFarmersDashboard from "./components/MyFarmers/MyFarmersDashboard";
// import { LoadingProvider } from "./context/LoadingContext";
// import LoadingIndicator from "./components/common/LoadingIndicator";
// import RequirementModule from "./pages/Requirement/RequirementModule";
// import GPRequirementModule from "./pages/Requirement/GlobalPartner/RequirementModule";
// import AMTPLRequirementModule from "./pages/Requirement/AMTPLRequirementModule/AMTPLReqModule";
// import AMTPLAddRequirementModule from "./pages/Requirement/AMTPLRequirementModule/AMTPLAddRequirement";
// import ProductOfferCharges from "./components/AMTPL/master/productOffers/ProductOffer";
// import InlandShipping from "./components/AMTPL/master/InlandShipping/Inlandshipping";
// import CountryWiseProduct from "./components/AMTPL/master/countryWiseProduct/CountryWiseProduct";
// import ProductCategory from "./components/AMTPL/master/productCategory/ProductCategory";
// import Product from "./components/AMTPL/master/product/Product";
// import Dashboard1 from "./pages/buyer/Dashboard";
// import DiscoverEvaluate from "./pages/buyer/DoscoverEvaluate/DoscoverEvaluate";
// import GPDiscoverEvaluate from "./pages/global-partner/my-trade/DiscoverEvaluate/DiscoverEvaluate";
// import RequirementBuyerModule from "./pages/buyer/requirement/RequirementBuyerModule";
// import RfqOffers from "./pages/buyer/frqOffers/RfqOffers";
// import Orders from "./pages/buyer/orders/Orders";
// import GPOrders from "./pages/global-partner/my-trade/orders/Orders";
// import Logistic from "./pages/buyer/logistic/Logistics";
// import Payment from "./pages/buyer/payment/Payment";
// import GPPayment from "./pages/global-partner/payment/Payment";
// import Communication from "./pages/buyer/communication/Communication";
// import BuyerProfileModule from "./pages/buyer/profileSetting/ProfileModule";
// import GPProfile from "./pages/global-partner/profileSetting/Profile";
// import GPOffersOld from "./pages/global-partner/my-trade/offers/offero";
// import Support from "./pages/buyer/support/Support";
// import GPSupport from "./pages/global-partner/support/Support";
// import Layout from "./pages/buyer/Components/layouts/layout";
// import AdminLayout from "./pages/AmtplAdmin/Components/layouts/layout";
// import GPLayout from "./pages/global-partner/Components/layouts/layout";
// import PageNotFound from "./pages/buyer/not-found/NotFound";
// import RfqsOffersModule from "./pages/buyer/finance-marketplace/RfqsOffers/RfqsOffersModule";
// import FinanceMarketModule from "./pages/buyer/finance-marketplace/FinanceMarketModule";
// import GPFinanceMarketModule from "./pages/global-partner/my-trade/finance-marketplace/FinanceMarketModule";
// import AmtplAdminDashboard from "./pages/AmtplAdmin/Dashboard";
// import BuyerActivityDashboard from "./pages/global-partner/buyer-activity/Dashboard";
// import MyTradeDashboard from "./pages/global-partner/my-trade/Dashboard";
// import AmtplProductModule from "./pages/AmtplAdmin/master/productModule/ProductModule";
// import AmtplProduce from "./pages/AmtplAdmin/produce/Produce";
// import AmtplOffers from "./pages/AmtplAdmin/offers/Offers";
// import AmtplEntities from "./pages/AmtplAdmin/entities/Entities";
// import AmtplCommunication from "./pages/AmtplAdmin/communication/Communication";
// import AmtplRequirements from "./pages/AmtplAdmin/requirements/Requirements";
// import AmtplRFQs from "./pages/AmtplAdmin/rfqs/Rfqs";
// import AmtplSupport from "./pages/AmtplAdmin/support/Support";
// import AmtplSettings from "./pages/AmtplAdmin/settings/Settings";
// import MyClients from "./pages/global-partner/MyClients";
// GB -section

// import GPmyTradeProfile from "./pages/global-partner/my-trade/profileSetting/Profile";
// Component to handle conditional catch-all routing
const NotFoundHandler = () => {
  const location = useLocation();
  const path = location.pathname;

  if (path.startsWith("/buyer")) {
    return (
      <Layout module="buyer">
        <PageNotFound />
      </Layout>
    );
  } else if (path.startsWith("/global-partner")) {
    return (
      <GPLayout module="buyer">
        <PageNotFound />
      </GPLayout>
    );
  } else if (path.startsWith("/seller-farmer")) {
    return (
      <SFLayout module="seller-farmer">
        <PageNotFound />
      </SFLayout>
    );
  } else if (path.startsWith("/finance-partner")) {
    return (
      <FPLayout module="fp">
        <PageNotFound />
      </FPLayout>
    );
  } else if (path.startsWith("/amtpla")) {
    return (
      <AdminLayout module="buyer">
        <PageNotFound />
      </AdminLayout>
    );
  } else {
    // Default to buyer layout for all other cases
    return (
      <Layout module="buyer">
        <PageNotFound />
      </Layout>
    );
  }
};

const ProtectedBuyerRoute = ({ children, setModal }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isKYBApproved, setIsKYBApproved] = useState(null);
  const [loading, setLoading] = useState(true);

  // Reset on every navigation
  const navigationKey = location.key; // changes on every navigation
  const hasShownAlert = useRef(new Set());

  const cleanPath = (path) =>
    path.split("?")[0].split("#")[0].replace(/\/$/, "");
  const currentCleanPath = cleanPath(location.pathname);

  const allowedPaths = [
    "/buyer/dashboard",
    "/buyer/profile",
    "/buyer/setting",
    "/buyer/support",
    "/buyer/discoverevaluate",
    "/buyer",
    "/buyer1",
  ];
  const isAllowed = allowedPaths.includes(currentCleanPath);

  // KYB Check Effect
  useEffect(() => {
    const checkKYBStatus = async () => {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const activeUser = cognitoUser.attributes.email;

        if (!activeUser) throw new Error("User email not found");

        const userKYBResponse = await fetchData({
          target: "listUserKYB",
          userOrder: "UserKybID",
          orderDirection: "ASC",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { EmailID: activeUser },
        });

        const approved =
          userKYBResponse.items?.length > 0 &&
          userKYBResponse.items[0].Status === "Approved";

        setIsKYBApproved(approved);
      } catch (error) {
        console.error("Error fetching KYB status:", error);
        setIsKYBApproved(false);
      } finally {
        setLoading(false);
      }
    };

    checkKYBStatus();
  }, [navigationKey]); // Re-run on every route change

  // Alert + Redirect Effect
  useEffect(() => {
    if (loading || isKYBApproved || isAllowed) return;

    const currentNavKey = navigationKey;

    // Prevent double alert in Strict Mode
    if (hasShownAlert.current.has(currentNavKey)) return;

    hasShownAlert.current.add(currentNavKey);

    // Show alert and redirect

    setModal({
      show: true,
      type: "info",
      title: "KYB not approved?",
      message: `Your KYB verification is currently pending or under review. \nPlease complete or wait for KYB approval to continue using your Grains Global buyer account.`,
      autoClose: false,
    });
    navigate("/buyer/dashboard", {
      replace: true,
      state: { from: location, kybBlocked: true },
    });
  }, [isKYBApproved, isAllowed, loading, navigate, location, navigationKey]);

  if (loading) {
    return <LoadingIndicator />;
  }

  // If blocked, render nothing — navigate handles redirect
  if (!isKYBApproved && !isAllowed) {
    return null;
  }

  return children;
};

const ProtectedGlobalPartnerRoute = ({ children, setModal }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isKYBApproved, setIsKYBApproved] = useState(null);
  const [loading, setLoading] = useState(true);

  // Reset on every navigation
  const navigationKey = location.key; // changes on every navigation
  const hasShownAlert = useRef(new Set());

  const cleanPath = (path) =>
    path.split("?")[0].split("#")[0].replace(/\/$/, "");
  const currentCleanPath = cleanPath(location.pathname);
  // Allowed paths even if not KYB approved (expand as needed)
  const allowedPaths = [
    "/global-partner/dashboard",
    "/global-partner/profile",
    "/global-partner/setting",
    "/global-partner/support",
    "/global-partner/discoverevaluate",
    "/global-partner",
  ];
  const isAllowed = allowedPaths.includes(currentCleanPath);
  // KYB Check Effect
  useEffect(() => {
    const checkKYBStatus = async () => {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const activeUser = cognitoUser.attributes.email;

        if (!activeUser) throw new Error("User email not found");

        const userKYBResponse = await fetchData({
          target: "listUserKYB",
          userOrder: "UserKybID",
          orderDirection: "ASC",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { EmailID: activeUser },
        });

        const approved =
          userKYBResponse.items?.length > 0 &&
          userKYBResponse.items[0].Status === "Approved";

        setIsKYBApproved(approved);
      } catch (error) {
        console.error("Error fetching KYB status:", error);
        setIsKYBApproved(false);
      } finally {
        setLoading(false);
      }
    };

    checkKYBStatus();
  }, [navigationKey]); // Re-run on every route change

  // Alert + Redirect Effect
  useEffect(() => {
    if (loading || isKYBApproved || isAllowed) return;

    const currentNavKey = navigationKey;

    // Prevent double alert in Strict Mode
    if (hasShownAlert.current.has(currentNavKey)) return;

    hasShownAlert.current.add(currentNavKey);

    // Show alert and redirect

    setModal({
      show: true,
      type: "info",
      title: "KYB not approved?",
      message: `Your KYB verification is currently pending or under review. \nPlease complete or wait for KYB approval to continue using your Grains Global partner account.`,
      autoClose: false,
    });
    navigate("/global-partner/dashboard", {
      replace: true,
      state: { from: location, kybBlocked: true },
    });
  }, [
    isKYBApproved,
    isAllowed,
    loading,
    navigate,
    location,
    navigationKey,
    setModal,
  ]);

  if (loading) {
    return <LoadingIndicator />;
  }

  // If blocked, render nothing — navigate handles redirect
  if (!isKYBApproved && !isAllowed) {
    return null;
  }
  return children;
};

const App = () => {
  const [modal, setModal] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
    autoClose: false,
  });

  // Initialize Google Analytics
  useEffect(() => {
    const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (GA_MEASUREMENT_ID) {
      initGA(GA_MEASUREMENT_ID);
    }
  }, []);

  // Initialize User Tracking (non-blocking)
  useEffect(() => {
    const cleanup = initUserTracking();
    return cleanup;
  }, []);

  // Modal handlers
  const handleModalClose = () => {
    setModal({
      show: false,
      type: "",
      title: "",
      message: "",
      autoClose: false,
    });
  };
  useEffect(() => {
    const listener = (event) => {
      try {
        if (
          event.payload.event === "signIn" ||
          event.payload.event === "verify"
        ) {
          const { data } = event.payload;
          const isMfaDefined = process.env.REACT_APP_MFANAME !== undefined;
          const mfaSetupReady =
            localStorage.getItem("mfasetupready") === "true";

          if (!isMfaDefined) {
            if (process.env.NODE_ENV === "development") {
              console.log("Sign-in data:", data);
            }
          } else if (
            isMfaDefined &&
            (data?.preferredMFA !== "NOMFA" || mfaSetupReady)
          ) {
            const username = data?.username || "";
            if (
              username.startsWith("okta_") ||
              username.startsWith("azuread_") ||
              username.startsWith("azureadopen_")
            ) {
              const userInfo = data?.signInUserSession?.idToken?.payload;
              if (userInfo && process.env.NODE_ENV === "development") {
                console.log("User info:", userInfo);
              }
            } else if (mfaSetupReady) {
              localStorage.removeItem("mfasetupready");
            }
          }
        } else if (event.payload.event === "signOut") {
          const transitions = localStorage.getItem("transitions");
          if (transitions !== "off" && process.env.NODE_ENV === "development") {
            console.log("User signed out");
          }
        }
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error("Error in Hub listener:", error);
        }
      }
    };

    Hub.listen("auth", listener);

    return () => Hub.remove("auth", listener);
  }, []);

  return (
    <LoadingProvider>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <Router>
        <GoogleAnalyticsTracker />
        <LoadingIndicator />
        <Routes>
          {/* Home Route */}
          <Route path="/" element={<Home />} />
          <Route path="/bank-info" element={<BankInfo />} />

          {/* Buyer Routes */}
          <Route
            path="/buyer"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Dashboard1 />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/dashboard"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Dashboard1 />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer1"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerDashboard />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/tradedashboard"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerMyTradeDashboard />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/discoverevaluate"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <DiscoverEvaluate />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/requirement"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <RequirementBuyerModule />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/rfqoffers"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <RfqOffers />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/documentvault"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerDocumentVault filter="All Documents" />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/kycdocuments"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerDocumentVault filter="KYC Document" />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/trade-contracts"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerDocumentVault filter="Trade Contracts / POs" />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/lc-sblc"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerDocumentVault filter="LC/SBLC Document" />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/invoices"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerDocumentVault filter="Invoices" />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/shipping-customs"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerDocumentVault filter="Shipping / Customs Docs" />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/orders"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Orders />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/logistic"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Logistic />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/payment"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Payment />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/communication"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Communication />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/profile"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerProfileModule />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/setting"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerSetting />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/support"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Support />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/finance/rfqoffers"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <RfqsOffersModule />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Dashboard1 />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/dashboard"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Dashboard1 />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer1"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerDashboard />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/discoverevaluate"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <DiscoverEvaluate />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/requirement"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <RequirementBuyerModule />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/rfqoffers"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <RfqOffers />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/orders"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Orders />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/logistic"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Logistic />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/payment"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Payment />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          {/* <Route
            path="/buyer/communication"
            element={
              <Layout module="buyer">
               <ProtectedBuyerRoute setModal={setModal}>
                <Communication />
                </ProtectedBuyerRoute>
              </Layout>
            }
          /> */}
          <Route
            path="/buyer/messaging"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerMessageModule />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/profile"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerProfileModule />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/support"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <Support />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/user-role"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <BuyerUserRoleModule />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />
          <Route
            path="/buyer/finance/rfqoffers"
            element={
              <Layout module="buyer">
                <ProtectedBuyerRoute setModal={setModal}>
                  <RfqsOffersModule />
                </ProtectedBuyerRoute>
              </Layout>
            }
          />

          {/* Global Partner Routes */}

          <Route
            path="/global-partner/dashboard"
            element={
              <GPLayout module="gp">
                <GPDashboard />
              </GPLayout>
            }
          />
          <Route
            path="/global-partner"
            element={
              <GPLayout module="gp">
                <GPDashboard />
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/trade/dashboard"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <MyTradeDashboard />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/requirement-old"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPRequirementOldModule />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/requirement"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPRequirementModule />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/rfqoffers"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GpRfqOffers />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/messaging"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPTradeMessageModule />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/offers"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPOffersOld />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/documentvault"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GpDocumentVault />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />

          <Route
            path="/global-partner/my-clients-old"
            element={
              <ProtectedGlobalPartnerRoute setModal={setModal}>
                <MyClientsDashboard />
              </ProtectedGlobalPartnerRoute>
            }
          />
          <Route
            path="/global-partner/support"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPSupport />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/payment"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPPayment />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/finance/rfqoffers"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GpRfqsOffersModule />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/discoverevaluate"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPDiscoverEvaluate />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/orders"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPOrders />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/profile"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPmyTradeProfile />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner/setting"
            element={
              <GPLayout module="gp">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPSetting />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          {/* global-partner-buyer */}

          <Route
            path="/global-partner-buyer"
            element={
              <GPLayout module="gpbuyer">
                <BuyerActivityDashboard />
              </GPLayout>
            }
          />
          <Route
            path="/global-partner-buyer/dashboard"
            element={
              <GPLayout module="gpbuyer">
                <BuyerActivityDashboard />
              </GPLayout>
            }
          />
          <Route
            path="/global-partner-buyer/my-buyers"
            element={
              <GPLayout module="gpbuyer">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <MyClients />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner-buyer/requirement"
            element={
              <GPLayout module="gpbuyer">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPBuyerRequirementModule />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner-buyer/rfqoffers"
            element={
              <GPLayout module="gpbuyer">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GpBuyerRfqOffers />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner-buyer/offers"
            element={
              <GPLayout module="gpbuyer">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <GPBuyerOffersModule />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          <Route
            path="/global-partner-buyer/trade"
            element={
              <GPLayout module="gpbuyer">
                <ProtectedGlobalPartnerRoute setModal={setModal}>
                  <Trade />
                </ProtectedGlobalPartnerRoute>
              </GPLayout>
            }
          />
          {/* AMTPL Procurement Routes */}
          <Route
            path="/amtpl-procurement"
            element={
              <AdminLayout module="amtpl_procurement">
                <AmtplProcurementDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl-procurement/dashboard"
            element={
              <AdminLayout module="amtpl_procurement">
                <AmtplProcurementDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl-procurement/master-data"
            element={
              <AdminLayout module="amtpl_procurement">
                <ProcurementMasterModule />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl-procurement/stratigic-partners"
            element={
              <AdminLayout module="amtpl_procurement">
                <StratigicPartners />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl-procurement/projects"
            element={
              <AdminLayout module="amtpl_procurement">
                <ProcurementProjects />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl-procurement/document-types"
            element={
              <AdminLayout module="amtpl_procurement">
                <ProcurementDocumentTypes />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl-procurement/project-documents"
            element={
              <AdminLayout module="amtpl_procurement">
                <ProcurementDocumentVault />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl-procurement/invoices"
            element={
              <AdminLayout module="amtpl_procurement">
                <ProcurementInvoices />
              </AdminLayout>
            }
          />

          {/* AMTPL Routes */}
          <Route
            path="/amtpl"
            element={
              <AdminLayout module="amtpl">
                <AmtplAdminDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/analytics"
            element={
              <AdminLayout module="amtpl">
                <AmtplAdminAnalytics />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/dashboard"
            element={
              <AdminLayout module="amtpl">
                <AmtplAdminDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/master"
            element={
              <AdminLayout module="amtpl">
                <AmtplProductModule />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/produce"
            element={
              <AdminLayout module="amtpl">
                <AmtplProduce />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/entities"
            element={
              <AdminLayout module="amtpl">
                <AmtplEntities />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/offers"
            element={
              <AdminLayout module="amtpl">
                <AmtplOffers />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/documentvault"
            element={
              <AdminLayout module="amtpl">
                <AdmDocumentVault filter="All Documents" />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/trade"
            element={
              <AdminLayout module="amtpl">
                <AmtplTrade />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/rfqs"
            element={
              <AdminLayout module="amtpl">
                <AmtplRFQs />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/communication"
            element={
              <AdminLayout module="amtpl">
                <AmtplCommunication />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/messaging"
            element={
              <AdminLayout module="amtpl">
                <AmtplMessageModule />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/support"
            element={
              <AdminLayout module="amtpl">
                <AmtplSupport />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/settings"
            element={
              <AdminLayout module="amtpl">
                <AmtplSettings />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/kyb"
            element={
              <AdminLayout module="amtpl">
                <KybModule />
              </AdminLayout>
            }
          />
          <Route
            path="/amtpl/kyc"
            element={
              <AdminLayout module="amtpl">
                <KycModule />
              </AdminLayout>
            }
          />
          <Route
            path="/finance-partner/dashboard"
            element={
              <FPLayout module="fp">
                <FPDashboard />
              </FPLayout>
            }
          />
          <Route
            path="/finance-partner"
            element={
              <FPLayout module="fp">
                <FPDashboard />
              </FPLayout>
            }
          />
          <Route
            path="/finance-partner/rfq"
            element={
              <FPLayout module="fp">
                <FPFinanceRfq />
              </FPLayout>
            }
          />

          <Route path="/amtplold" element={<AMTPLDashboard />} />
          <Route
            path="/amtplold/requirement"
            element={<AMTPLRequirementModule />}
          />
          <Route
            path="/amtplold/addrequirement"
            element={<AMTPLAddRequirementModule />}
          />
          <Route
            path="/amtplold/productofferscharges"
            element={<ProductOfferCharges />}
          />
          <Route path="/amtplold/inlandshipping" element={<InlandShipping />} />
          <Route
            path="/amtplold/counrywiseproduct"
            element={<CountryWiseProduct />}
          />
          <Route
            path="/amtplold/productcategory"
            element={<ProductCategory />}
          />
          <Route path="/amtplold/product" element={<Product />} />

          {/* Other Routes */}
          <Route
            path="/seller-farmer"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerDashboard />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/dashboard"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerDashboard />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/my-offers"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerDashboardOld />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/produce"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerProduce />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/profile"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerProfileModule />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/setting"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerSetting />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/support"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerSupport />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/messaging"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerMessageModule />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/documentvault"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerDocumentVault />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/requirement"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerRequirementModule />
              </SFLayout>
            }
          />
          <Route
            path="/seller-farmer/rfqoffers"
            element={
              <SFLayout module="seller-farmer">
                <SellerFarmerRfqOffersModule />
              </SFLayout>
            }
          />
          <Route path="/agropreneur" element={<AgroPreneurDashboard />} />
          <Route path="/requirement" element={<RequirementModule />} />
          <Route path="/my-clients" element={<MyClientsDashboard />} />
          <Route path="/my-farmers" element={<MyFarmersDashboard />} />

          {/* Login Routes */}
          <Route path="/login/autologin" element={<LoginAuto />} />
          <Route path="/login/buyer" element={<BuyerLogin />} />
          <Route
            path="/login/global-partner"
            element={<GlobalPartnerLogin />}
          />
          <Route path="/login/finance-partner" element={<FinanceLogin />} />

          <Route path="/login/seller-farmer" element={<SellerFarmerLogin />} />
          <Route path="/login/agropreneur" element={<AgroPreneurLogin />} />
          <Route path="/login/amtpl" element={<AMTPLLogin />} />

          {/* Password Reset Routes */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/kyc" element={<ProfilekycStepper />} />
          <Route path="/login/autologin" element={<LoginAuto />} />
          {/* Conditional Catch-All Route */}
          <Route path="*" element={<NotFoundHandler />} />
        </Routes>
      </Router>
    </LoadingProvider>
  );
};

export default App;
// Test deployment
